/**
 * Thrown when trying to find a swimlane within
 * the SwimlaneStore but cannot find it
 */
class SwimlaneNotFoundError extends Error {
    constructor(boardId: number, swimlaneId: number) {
        super(
            `SwimlaneNotFound: { boardId:${boardId}, swimlaneId:${swimlaneId} }`
        )
        this.name = 'SwimlaneNotFoundError'
    }
}

export default SwimlaneNotFoundError
